// imgrowPlugin.js
export default function (md) {
  function parseHeader(line) {
    // :::imagerow columns=2 gap=12
    const rest = line.slice(":::imagerow".length).trim();
    const attrs = {};
    const re = /(\w+)=(".*?"|'.*?'|[^\s]+)/g;
    let m;
    while ((m = re.exec(rest))) {
      let v = m[2];
      if ((v.startsWith('"') && v.endsWith('"')) || (v.startsWith("'") && v.endsWith("'"))) {
        v = v.slice(1, -1);
      }
      if (v === "true") v = true;
      else if (v === "false") v = false;
      else if (!Number.isNaN(Number(v)) && v.trim() !== "") v = Number(v);
      attrs[m[1]] = v;
    }
    return attrs;
  }

  function imgrowBlock(state, startLine, endLine, silent) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    const firstLine = state.src.slice(start, max);

    if (!firstLine.startsWith(":::imagerow")) return false;
    if (silent) return true;

    // find closing :::
    let nextLine = startLine + 1;
    let found = false;
    while (nextLine < endLine) {
      const s = state.bMarks[nextLine] + state.tShift[nextLine];
      const e = state.eMarks[nextLine];
      const l = state.src.slice(s, e).trim();
      if (l === ":::") {
        found = true;
        break;
      }
      nextLine++;
    }
    if (!found) return false;

    const header = parseHeader(firstLine);

    // tokenize inner lines so we get image tokens
    const open = state.push("imgrow_open", "", 1);
    open.meta = header;

    const innerStart = startLine + 1;
    const innerEnd = nextLine;
    state.md.block.tokenize(state, innerStart, innerEnd);

    state.push("imgrow_close", "", -1);

    state.line = nextLine + 1;
    return true;
  }

  md.block.ruler.before("fence", "imgrow_container", imgrowBlock, {
    alt: ["paragraph", "reference", "blockquote", "list"],
  });

  // collapse: imgrow_open..imgrow_close -> one token "imgrow" with images[]
  md.core.ruler.push("collapse_imgrow", (state) => {
    const tokens = state.tokens;
    const out = [];

    for (let i = 0; i < tokens.length; i++) {
      const t = tokens[i];

      if (t.type !== "imgrow_open") {
        out.push(t);
        continue;
      }

      const columns = t.meta?.columns ?? 2;
      const gap = t.meta?.gap ?? 12;

      const images = [];
      i++;
      for (; i < tokens.length; i++) {
        const cur = tokens[i];
        if (cur.type === "imgrow_close") break;

        if (cur.type === "inline" && cur.children) {
          for (const c of cur.children) {
            if (c.type !== "image") continue;

            images.push({
              src: c.attrGet("src") || "",
              alt: c.content || c.attrGet("alt") || "",
            });
          }
        }
      }

      const row = new state.Token("imagerow", "", 0);
      row.block = true;
      row.attrs = [
        ["columns", String(columns)],
        ["gap", String(gap)],
        ["images", JSON.stringify(images)],
      ];
      out.push(row);
    }

    state.tokens = out;
  });
}
